<template>
  <router-link :to="{ name: 'Category', params: { id: category.id } }">
    <div class="category-item bg-brand py-3 mb-3 rounded-md text-light text-center d-flex flex-column">
      <div class="icon flex-grow-0">
        <img :src="category.icon_url" alt="">
      </div>
      <div class="label font-weight-bold text-sm flex-grow-1 d-flex align-items-center justify-content-center">
        <span>{{ category.name_ar }}</span>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: ['category'],
};
</script>

<style scoped>
.category-item {
  height: 120px;
  width: 100%;
}

.icon img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.label {
  word-break: break-word;
  padding: 0 8px;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.label span {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (min-width: 768px) {
  .category-item {
    height: 150px;
  }
  
  .label span {
    -webkit-line-clamp: 4;
  }
}
</style>
